import { useState, useCallback } from 'react';

interface CanvasTransform {
  panX: number;
  panY: number;
  zoom: number;
}

export function useCanvasTransform() {
  const [transform, setTransform] = useState<CanvasTransform>({
    panX: 0,
    panY: 0,
    zoom: 1,
  });

  const handleWheel = useCallback((e: React.WheelEvent) => {
    e.preventDefault();
    setTransform((prev) => {
      const newZoom = Math.max(0.3, Math.min(2, prev.zoom - e.deltaY * 0.001));
      return { ...prev, zoom: newZoom };
    });
  }, []);

  const resetTransform = useCallback(() => {
    setTransform({ panX: 0, panY: 0, zoom: 1 });
  }, []);

  const zoomIn = useCallback(() => {
    setTransform((prev) => ({ ...prev, zoom: Math.min(2, prev.zoom + 0.1) }));
  }, []);

  const zoomOut = useCallback(() => {
    setTransform((prev) => ({ ...prev, zoom: Math.max(0.3, prev.zoom - 0.1) }));
  }, []);

  const pan = useCallback((dx: number, dy: number) => {
    setTransform((prev) => ({ ...prev, panX: prev.panX + dx, panY: prev.panY + dy }));
  }, []);

  return { transform, handleWheel, resetTransform, zoomIn, zoomOut, pan };
}
